/**
 * @fileoverview Barrel exports for the a-storyline-extractor-v1 agent.
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
  type StorylineOutput,
  type BeatOutput,
  type StoryQuestionOutput,
} from './schema';

// Flow
export { flow, aStorylineExtractorV1AgentFlow } from './flow';

// Prompt template
export { prompt } from './prompt';
